export default __webpack_public_path__ + "static/media/AllCards.f872cd0c.svg";